import React from 'react';
import './Sparkles.scss';

export type SparklesTrend = 'rising' | 'falling' | 'neutral';

interface SparklesProps {
  /** `ico--*` class of the icon in the middle. */
  icon?: string;
  /** Image in the middle instead of an icon (e.g. an integration's logo). */
  image?: string;
  /** rising = greens + twinkle, falling = reds + twinkle, neutral = still greys. */
  trend?: SparklesTrend;
  /** e.g. `sparkles--watermark` — large, faded, cropped in the parent's top-left corner. */
  className?: string;
  /** 4 (default) or up to 8 — the extra ones fill the gaps around the icon. */
  sparks?: number;
}

/** Corner decoration: one icon with four-point sparkles around it. The parent must be `position: relative`. */
const Sparkles: React.FC<SparklesProps> = ({ icon, image, trend = 'neutral', className, sparks = 4 }) => (
  <span
    className={['sparkles', trend !== 'neutral' && `sparkles--${trend}`, className]
      .filter(Boolean)
      .join(' ')}
    aria-hidden="true"
  >
    {image ? (
      <img className="sparkles__badge sparkles__badge--image" src={image} alt="" />
    ) : (
      <span className={`ico ${icon} sparkles__badge`} />
    )}
    {Array.from({ length: Math.min(sparks, 8) }, (_, i) => (
      <span key={i} className="sparkles__spark" />
    ))}
  </span>
);

export default Sparkles;
